import React from "react";
import { GridLoader } from "react-spinners";
import styles from "./LoadingOverlay.module.scss";

const LoadingOverlay: React.FC = () => {
  return (
    <div className={styles.loadingOverlay}>
      <GridLoader color="#00b9ff" size={15} />
    </div>
  );
};

export default LoadingOverlay;
